export const FOOD_NAME_AR = {
  Apple: "تفاح",
  Blueberries: "توت أزرق",
  Grapes: "عنب",
  Pineapple: "أناناس",
  Strawberries: "فراولة",
  Banana: "موز",
  Orange: "برتقال",
  Watermelon: "بطيخ",
  "White bread": "خبز أبيض",
  "Whole wheat bread": "خبز قمح كامل",
  "White rice": "أرز أبيض",
  "Brown rice": "أرز بني",
  Pasta: "معكرونة",
  Oatmeal: "شوفان",
  Cornflakes: "كورن فليكس",
  "Chicken breast": "صدر دجاج",
  Beef: "لحم بقر",
  "Egg whites": "بياض البيض",
  "Whole egg": "بيضة كاملة",
  Tuna: "تونة",
  Salmon: "سلمون",
  Milk: "حليب",
  "Cheddar cheese": "جبنة شيدر",
  "Cream cheese": "جبنة كريمية",
  Yogurt: "لبن",
  "Cottage cheese": "جبنة قريش",
  Butter: "زبدة",
  "Olive oil": "زيت زيتون",
  Potato: "بطاطا",
  "Sweet potato": "بطاطا حلوة",
  Carrots: "جزر",
  "Green beans": "فاصوليا خضراء",
  Cucumber: "خيار",
  Lettuce: "خس",
  Tomato: "بندورة",
  "Tomato sauce": "صلصة بندورة",
  Onion: "بصل",
  Garlic: "ثوم",
  Hummus: "حمص",
  Lentils: "عدس",
  Chickpeas: "حمص حب",
  Almonds: "لوز",
  "Peanut butter": "زبدة الفول السوداني",
  "Rice milk": "حليب أرز",
  Soda: "مشروبات غازية",
  "Herbal tea": "شاي أعشاب",
  Coffee: "قهوة",
  Olives: "زيتون",
  Zaatar: "زعتر",
  Manouche: "منقوشة",
};

export const CATEGORY_AR = {
  Beverages: "مشروبات",
  Dairy: "ألبان",
  Fats: "دهون",
  Fruits: "فاكهة",
  Grains: "حبوب ونشويات",
  Lebanese: "أطعمة لبنانية",
  Legumes: "بقوليات",
  Nuts: "مكسرات",
  Proteins: "بروتينات",
  Vegetables: "خضار",
};

export const SERVING_AR = {
  "1 medium": "حبة متوسطة",
  "1/2 cup": "نصف كوب",
  "1 cup": "كوب واحد",
  "1 slice": "شريحة واحدة",
  "85g": "٨٥ غ",
  "2 large": "حبتان كبيرتان",
  "1 large": "حبة كبيرة",
  "28g": "٢٨ غ",
  "2 tbsp": "ملعقتان كبيرتان",
  "1 tbsp": "ملعقة كبيرة",
  "1 clove": "فص واحد",
  "1 can": "علبة واحدة",
  "10 pcs": "١٠ حبات",
  "1 pc": "قطعة واحدة",
};

export const localizeFoodName = (name, lang) => {
  if (lang !== "ar") return name || "";
  return FOOD_NAME_AR[name] || name || "";
};

export const localizeCategory = (category, lang) => {
  if (lang !== "ar") return category || "";
  return CATEGORY_AR[category] || category || "";
};

export const localizeServing = (serving, lang) => {
  if (lang !== "ar") return serving || "";
  return SERVING_AR[serving] || serving || "";
};
